import { ActionType } from '../../../definitions/types/ActionType';
import { BlockNumberType } from '../../../definitions/types/BlockNumber';
import { EntityType } from '../../../definitions/types/Entity';
import { StateType } from '../../../definitions/types/StateType';
import { urlFromState } from '../../../utils/helpers/urlFromState';

export const selectReducer = (
  state: StateType,
  action: ActionType,
): StateType => {
  const payload: EntityType = action.payload as EntityType;
  const newState = { ...state };

  state.entities.forEach((entity, i) => {
    if (entity.type === payload.type && entity.id === payload.id) {
      newState.selected = {
        ...payload,
        number: `${i + 1}` as BlockNumberType,
      };

      if (!newState.selected.label) {
        newState.selected.label = entity.label;
      }
    }
  });

  newState.url = urlFromState(newState);

  return newState;
};
